// extracted by mini-css-extract-plugin
export var aiStarSpin = "_ms-1";
export var spinner = "_ms-0";